import { Injectable } from '@angular/core';
import {environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EncrDecrService } from '../../services/encr-decr.service';


@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { }

  getUsersList(userType) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'user/list',{"user_type": userType},{headers: headers_object}).toPromise()
  }

  addUser(data) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'user-add', data,{headers: headers_object}).toPromise()
  }

  blockUser(id) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + 'user/block/'+id, {headers: headers_object}).toPromise()
  }

  addAdmin(data) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'admin-add', data, {headers: headers_object}).toPromise()
  }

  deactivate(id) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + 'user/deactivate/'+id, {headers: headers_object}).toPromise()
  }

  promoteToAdmin(id){
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'change-prior/'+id, {}, {headers: headers_object}).toPromise()
  }
}
